import { Link } from "react-router-dom";
import { LogIn, ArrowLeft } from "lucide-react";

export default function LoginPage() {
  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(
      redirectUrl
    )}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7] bg-grain px-6">
      <div className="w-full max-w-md bg-white rounded-2xl border border-[#E5E7EB] p-10 shadow-sm">
        <Link
          to="/"
          data-testid="login-back-home"
          className="inline-flex items-center gap-2 text-sm text-[#3F6255] hover:text-[#064E3B] mb-6"
        >
          <ArrowLeft size={16} /> Back to home
        </Link>
        <h1 className="font-display text-3xl font-bold text-[#022C22] tracking-tight">
          Admin Sign in
        </h1>
        <p className="text-[#3F6255] mt-2 mb-8">
          Internal dashboard for the GST24 Mumbai team.
        </p>
        <button
          type="button"
          data-testid="google-login-button"
          onClick={handleGoogleLogin}
          className="btn-primary w-full justify-center"
        >
          <LogIn size={18} />
          Continue with Google
        </button>
        <p className="text-xs text-[#64748B] mt-6 text-center">
          Authorised Google accounts only.
        </p>
      </div>
    </div>
  );
}
